module.exports = __webpack_public_path__ + "img/feature-item-schedule.935bb15f.svg";